import axios from '../Util/AxiosIntercepted';

function getSlideReactionState(roomId, slideId) {
    return axios
        .get(`/vyu/api/v1/rooms/${roomId}/slides/${slideId}/reactions`)
        .then(({ data }) => data)
        .catch((e) => {
            const message = e.response?.data?.message || e.message || 'Failed to load reactions';
            throw new Error(message);
        });
}

function react(roomId, slideId, reactionType) {
    return axios
        .post(`/vyu/api/v1/rooms/${roomId}/slides/${slideId}/reactions`, { reactionType })
        .then(({ data }) => data)
        .catch((e) => {
            const message = e.response?.data?.message || e.message || 'Failed to send reaction';
            throw new Error(message);
        });
}

export default {
    getSlideReactionState,
    react
};
